<template>
  <div class="container">
    <div id="title">
      <span
        >いつもの味を、ご自宅までお届け<br />お好みのサービスをご利用ください</span
      >
    </div>
    <div class="example">
      <div
        @click="
          openNetStore('https://demae-can.com/chain/top/312900/')
          trapTrackDeliveryEvent('demae-can')
        "
      >
        <img src="@/assets/img/delivery/demaekan_btn.png" alt="" />
      </div>
      <div
        @click="
          openNetStore('https://app.menu.jp/')
          trapTrackDeliveryEvent('app.menu')
        "
      >
        <img src="@/assets/img/delivery/menu_btn.png" alt="" />
      </div>
    </div>
    <div class="example">
      <div
        @click="
          openNetStore('https://www.ubereats.com/jp')
          trapTrackDeliveryEvent('Uber-Eats')
        "
      >
        <img src="@/assets/img/delivery/uber_btn.png" alt="" />
      </div>
      <div
        @click="
          openNetStore('https://wolt.com/ja')
          trapTrackDeliveryEvent('Wolt')
        "
      >
        <img src="@/assets/img/delivery/walt_btn.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { FactoryTrack } from '@/constant/firebase'
export default {
  name: 'Delivery',
  created() {
    document.title = '宅配サービス'
    this.trackEvent(FactoryTrack.createNetorder())
  },
  methods: {
    ...mapActions('Analytics', ['trackEvent']),
    ...mapActions('Native', ['actionRequestExternalLink']),
    openNetStore(url) {
      this.actionRequestExternalLink(url)
    },
    trapTrackDeliveryEvent(caption) {
      this.trackEvent(FactoryTrack.createDeliveryService(caption))
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  min-height: 100%;
  background-color: #ffffff;

  #image_area {
    width: 100%;
    height: auto;
  }

  #image_area img {
    width: 100%;
    height: auto;
  }

  #title {
    width: 100%;
    margin-top: 30px;
    margin-bottom: 30px;
    text-align: center;
    font-weight: bold;
    font-size: 16px;
    color: rgba(90, 34, 0, 1);
  }
  #title span {
    width: 100%;
  }
  .example {
    width: 98%;
    display: flex;
  }
  .example > div {
    width: 50%;
    margin-left: 10px;
    margin-bottom: 10px;
  }

  .example > div img {
    width: 97%;
  }
}
</style>
